module.exports = __webpack_public_path__ + "assets/img/slat_close6_AR.8aed28c2.svg";